<script setup lang="ts">
import { useRouter } from 'vue-router';

import Modal from '@/components/base/layout/Modal.vue';
import ThemedButton from '@/components/base/ThemedButton.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header4 from '@/components/base/typography/Header4.vue';

defineProps<{ showError: boolean }>();

const router = useRouter();

const handleCloseRedemptionErrorModal = () => {
  router.push('/custom/box');
};

const nutIcon = nutshell['static_img/custom-builder/Oh-no-nut.svg'];
</script>

<template>
  <Modal
    aria-label="Redemption Error Modal"
    :hasControls="false"
    :isOpen="showError"
    width="md:max-w-sm"
    @handle-close="handleCloseRedemptionErrorModal"
  >
    <template #body>
      <div class="flex flex-col items-center justify-center">
        <img :src="nutIcon" alt="Something's wrong Nut icon" />
        <Header4 class="text-center"> Uh oh. Something went wrong. </Header4>
        <BaseBodyText class="mt-4 text-center text-neutral-500">
          Looks like your redemption link has expired. Please contact customer service at
          1-800-558-6887 or 908-523-0333 or email us at
          <a class="inline-block" href="mailto:care@nuts.com">care@nuts.com</a>.
        </BaseBodyText>
        <ThemedButton class="mt-4" theme="gray" @click="handleCloseRedemptionErrorModal">
          Ok
        </ThemedButton>
      </div>
    </template>
  </Modal>
</template>
